import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './question.css'

const Question = (props) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div
      onClick={() => setIsOpen(!isOpen)}
      className={`question-container1 ${props.rootClassName} `}
    >
      <div className="question-container2">
        <span className="question-text1">{props.head}</span>
        {isOpen === false && (
          <img
            alt="image"
            src="/external/pastedimage-0qvq.svg"
            className="question-image1"
          />
        )}
        {isOpen === true && (
          <img
            alt="image"
            src="/external/pastedimage-0qvq.svg"
            className="question-image2"
          />
        )}
      </div>
      {isOpen === true && (
        <span className="question-text2">{props.content}</span>
      )}
    </div>
  )
}

Question.defaultProps = {
  rootClassName: '',
  content: 'Text',
  head: 'Text',
}

Question.propTypes = {
  rootClassName: PropTypes.string,
  content: PropTypes.string,
  head: PropTypes.string,
}

export default Question
